import $ from "jquery";
import { round } from "../../technical/numbers";
$(document).on("blur", "input.currency-format", (e) => {
    const input = $(e.currentTarget);
    const parsed = parseFloat(input.val());
    if (isNaN(parsed))
        return;
    const decimalPlaces = input.data("decimal-places") || 2;
    input.val(round(parsed, decimalPlaces).toFixed(decimalPlaces));
});
